<i18n>
{
  "en": {
    "alignContent": "Justify the content on the horizontal axis",
    "background": "Background",
    "borderBottom": "Border bottom",
    "borderEnable": "Enable borders",
    "borderLeft": "Border left",
    "borderRight": "Border right",
    "borders": "Borders",
    "borderTop": "Border top",
    "borderWidthGridItem": "Border width",
    "center": "Center",
    "clauses": "Clauses",
    "customFontSize": "Use custom font size",
    "end": "Final",
    "font": "Font",
    "fontSizeGridItem": "Font size",
    "fontSizeThreshold": "Font size threshold",
    "fontSizeUnit": "Units",
    "general": "General",
    "gridItemConfiguration": "Grid item configuration",
    "hideTitle": "Hide title",
    "image": "Select background image",
    "invalidNumberError": "Invalid number",
    "justify": "Justify & Align",
    "justifyContent": "Justify the content on the vertical axis",
    "labelBackgroundColor": "Background color",
    "labelFontColor": "Font color",
    "left": "Left",
    "lineHeightGridItem": "Line height",
    "margins": "Margins",
    "paddingLeftGridItem": "Item margin left",
    "paddingTopGridItem": "Item margin top",
    "paddingRightGridItem": "Item margin right",
    "paddingBottomGridItem": "Item margin bottom",
    "right": "Right",
    "showMasterSaleFormat": "Show sale format title",
    "start": "Start",
    "stretch": "Stretch",
    "textAlign": "Text align",
    "useBackgroundColor": "Use custom background color",
    "useCustomFontColor": "Use custom color for text",
    "useCustomFontSize": "Use custom font size",
    "useFontSizeRatio": "Use font size ratio",
    "useLineHeight": "Use custom line height"
  },
  "es": {
    "alignContent": "Justificar el contenido en el eje horizontal",
    "background": "Fondo",
    "borderBottom": "Borde inferior",
    "borderEnable": "Habilitar bordes",
    "borderLeft": "Borde izquierdo",
    "borderRight": "Borde derecho",
    "borders": "Bordes",
    "borderTop": "Borde superior",
    "borderWidthGridItem": "Tamaño del borde",
    "center": "Centro",
    "clauses": "Apartados",
    "customFontSize": "Utilizar tamaño de fuente personalizado",
    "end": "Final",
    "font": "Letra",
    "fontSizeGridItem": "Tamaño de fuente",
    "fontSizeThreshold": "Factor de crecimiento",
    "fontSizeUnit": "Unidades",
    "general": "General",
    "gridItemConfiguration": "Configuración del apartado",
    "hideTitle": "Ocultar el título",
    "image": "Seleccione imagen de fondo",
    "invalidNumberError": "Número inválido",
    "justify": "Justificar Y Alinear",
    "justifyContent": "Justificar el contenido en el eje vertical",
    "labelBackgroundColor": "Color de fondo",
    "labelFontColor": "Color de la fuente",
    "left": "Izquierda",
    "lineHeightGridItem": "Interlineado del texto",
    "margins": "Margenes",
    "paddingLeftGridItem": "Margen del item izquierdo",
    "paddingTopGridItem": "Margen del item superior",
    "paddingRightGridItem": "Margen del item derecho",
    "paddingBottomGridItem": "Margen del item inferior",
    "right": "Derecha",
    "start": "Inicio",
    "stretch": "Justificado",
    "textAlign": "Alineamiento del texto",
    "showMasterSaleFormat": "Mostrar el título del formato de venta",
    "useBackgroundColor": "Utilizar un color de fondo personalizado",
    "useCustomFontColor": "Utilizar un color de texto personalizado",
    "useCustomFontSize": "Usar tamaño personalizado",
    "useFontSizeRatio": "Usar factor de crecimiento",
    "useLineHeight": "Utilizar un interlineado de texto personalizado"
  }
}
</i18n>
<template>
  <v-form :disabled="!selectedGridItemConfiguration" class="form-grid-item-config">
    <div class="subtitle-grid-item">{{ $t('gridItemConfiguration') }}</div>
    <v-tabs
      v-model="tab"
      class="my-tabs"
      background-color="transparent"
      :show-arrows="true"
      next-icon="mdi-arrow-right-bold-box-outline"
      prev-icon="mdi-arrow-left-bold-box-outline"
    >
      <v-tab>{{ $t('general') }}</v-tab>
      <v-tab>{{ $t('justify') }}</v-tab>
      <v-tab>{{ $t('font') }}</v-tab>
      <v-tab>{{ $t('borders') }}</v-tab>
      <v-tab>{{ $t('background') }}</v-tab>
      <v-tab>{{ $t('margins') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" data-testid="tab-input">
      <v-tab-item class="mt-5">
        <v-row class="w-100 mx-0" align="baseline">
          <v-col cols="6">
            <v-checkbox
              v-model="form.hideTitle"
              data-testid="hide-title-input"
              dense
              :label="$t('hideTitle')"
              class="pt-2 mt-0 mx-2 ml-3 master-product-input"
            />
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="form.showMasterSaleFormat"
              data-testid="show-master-sale-format-input"
              dense
              :label="$t('showMasterSaleFormat')"
              class="pt-2 mt-0 mx-2 ml-3 master-product-input"
            />
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="mt-5">
        <v-row class="mx-0 w-100">
          <v-col cols="6">
            <v-select
              v-model="form.justifyContent"
              :items="alignsOptions"
              :label="$t('justifyContent')"
              outlined
              item-value="value"
              item-text="name"
              data-testid="justify-input"
              class=""
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="form.alignContent"
              :items="alignsOptions"
              :label="$t('alignContent')"
              outlined
              item-value="value"
              item-text="name"
              data-testid="align-input"
              class="ml-2"
            />
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="mt-5">
        <v-row class="w-100 mx-0" align="baseline">
          <v-col>
            <v-checkbox
              v-model="form.useCustomFontSize"
              data-testid="hide-title-input"
              dense
              :label="$t('useCustomFontSize')"
              class="pt-2 mt-0 mx-2 ml-3 master-product-input"
            />
          </v-col>
        </v-row>
        <v-row class="w-100 mx-0" align="baseline">
          <v-col>
            <v-checkbox
              v-if=form.useCustomFontSize
              v-model="form.useFontSizeRatio"
              data-testid="hide-title-input"
              dense
              :label="$t('useFontSizeRatio')"
              class="pt-2 mt-0 mx-2 ml-3 master-product-input"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="!form.useFontSizeRatio && form.useCustomFontSize"
          class="w-100 mx-0"
          align="baseline"
        >
          <v-col cols="7">
            <v-text-field
              outlined type="number"
              v-model="form.fontSize"
              data-testid="padding-item-input"
              :label="$t('fontSizeGridItem')"
              class="required"
            />
          </v-col>
          <v-col cols="5" class="px-2">
            <v-select
              v-model="form.fontSizeUnit"
              :items="fontUnitOptions"
              :label="$t('fontSizeUnit')"
              outlined
              item-value="value"
              item-text="name"
              data-testid="justify-input"
              class="required"
            />
          </v-col>
        </v-row >
        <v-row
          v-if="form.useFontSizeRatio && form.useCustomFontSize"
          class="w-100 mx-0"
          align="baseline"
        >
          <v-col>
            <v-text-field
              outlined
              type="number"
              v-model="form.fontSizeThreshold"
              data-testid="padding-item-input"
              :rules="fontSizeNumberRules"
              :label="$t('fontSizeThreshold')"
              class="required"
            />
          </v-col>
        </v-row>
        <v-row class="w-100 mx-0" align="baseline">
          <v-col>
            <v-checkbox
              v-model="form.useLineHeight"
              data-testid="hide-title-input"
              dense
              :label="$t('useLineHeight')"
              class="pt-2 mt-0 mx-2 ml-3 master-product-input"
            />
          </v-col>
        </v-row>
        <v-row class="w-100 mx-0" align="baseline">
          <v-col>
            <v-text-field
              v-if=form.useLineHeight
              outlined type="number"
              v-model="form.lineHeight"
              data-testid="padding-item-input"
              :rules="lineHeightRules"
              :label="$t('lineHeightGridItem')"
              class="required"
            />
          </v-col>
        </v-row>
        <v-row class="w-100 mx-0" align="baseline">
          <v-col cols="12">
            <v-select
              v-model="form.textAlign"
              :items="textAlignsOptions"
              :label="$t('textAlign')"
              outlined
              item-value="value"
              item-text="name"
              data-testid="justify-input"
              class=""
            />
          </v-col>
        </v-row>
        <v-row class="w-100 mx-0" align="baseline">
          <v-col>
            <v-checkbox
              v-model="form.useCustomFontColor"
              data-testid="hide-title-input"
              dense
              :label="$t('useCustomFontColor')"
              class="pt-2 mt-0 mx-2 ml-3 master-product-input"
            />
          </v-col>
        </v-row>
        <v-row class="w-100 mx-0" align="baseline">
          <v-col v-if=form.useCustomFontColor>
            <label
              class="v-label v-label--active theme--light position-elements">{{
                $t('labelFontColor')
              }}</label>
            <v-color-picker
              v-model="form.fontColor"
              hide-mode-switch
              mode="hexa">
            </v-color-picker>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="mt-5">
        <v-row class="w-100 mx-0" align="baseline">
          <v-col cols="12">
            <v-text-field
              outlined type="number"
              v-model="form.borderWidth"
              data-testid="padding-item-input" :rules="borderWidthRules"
              :label="$t('borderWidthGridItem')"
              class="required"
            />
          </v-col>
        </v-row>
        <v-row class="w-100 mx-0" align="baseline">
          <v-col cols="6">
            <v-checkbox
              v-model="form.borderTop"
              data-testid="border-top-input"
              dense
              :label="$t('borderTop')"
              class="pt-2 mt-0 mx-2 master-product-input"
            />
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="form.borderBottom"
              data-testid="border-bottom-input"
              dense
              :label="$t('borderBottom')"
              class="pt-2 mt-0 mx-2 master-product-input"
            />
          </v-col>
        </v-row>
        <v-row class="w-100 mx-0" align="baseline">
          <v-col cols="6">
            <v-checkbox
              v-model="form.borderRight"
              data-testid="border-right-input"
              dense
              :label="$t('borderRight')"
              class="pt-2 mt-0 mx-2 master-product-input"
            />
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="form.borderLeft"
              data-testid="border-left-input"
              dense
              :label="$t('borderLeft')"
              class="pt-2 mt-0 mx-2 master-product-input"
            />
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="mt-5">
        <v-row class="w-100 mx-0" align="baseline">
          <v-col cols="6">
            <label
              class="v-label v-label--active theme--light position-elements"
            >{{
                $t('labelBackgroundColor')
              }}</label>
            <v-color-picker
              v-model="form.backgroundColor"
              hide-mode-switch
              mode="hexa">
            </v-color-picker>
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="form.useBackgroundColor"
              data-testid="hide-title-input"
              dense
              :label="$t('useBackgroundColor')"
              class="pt-2 mt-0 mx-2 ml-3 master-product-input"
            />
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="mt-5">
        <v-row class="w-100 mx-0" align="baseline">
          <v-col cols="6" class="px-1">
            <v-text-field
              outlined type="number"
              v-model="form.paddingTop"
              data-testid="padding-item-input"
              :rules="numberRules"
              :label="$t('paddingTopGridItem')"
              class="required"
            />
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              outlined
              type="number"
              v-model="form.paddingBottom"
              data-testid="padding-item-input"
              :rules="numberRules"
              :label="$t('paddingBottomGridItem')"
              class="required"
            />
          </v-col>
        </v-row>
        <v-row class="w-100 mx-0" align="baseline">
          <v-col cols="6" class="px-1">
            <v-text-field
              outlined
              type="number"
              v-model="form.paddingLeft"
              data-testid="padding-item-input"
              :rules="numberRules"
              :label="$t('paddingLeftGridItem')"
              class="required"
            />
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field
              outlined
              type="number"
              v-model="form.paddingRight"
              data-testid="padding-item-input"
              :rules="numberRules"
              :label="$t('paddingRightGridItem')"
              class="required"
            />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-form>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Watch } from 'vue-property-decorator';
import { MapGetters, MapActions } from '@core/helpers/decorators';
import {
  notNumberInBetweenNegative,
  notValidNumber
} from '@core/helpers/formValidators';

@Component
@MapGetters(['selectedGridItemConfiguration'])
@MapActions(['updateMenuGridItemConfiguration'])
export default class GridItemForm extends Vue {
  form = {
    hideTitle: false,
    showMasterSaleFormat: false,
    justifyContent: '',
    alignContent: '',
    useFontSizeRatio: true,
    fontSize: 1,
    fontSizeUnit: 'px',
    fontSizeThreshold: 0,
    useCustomFontSize: false,
    lineHeight: 1,
    useLineHeight: false,
    textAlign: '',
    fontColor: '',
    useCustomFontColor: false,
    borderWidth: 1,
    borderTop: false,
    borderBottom: false,
    borderRight: false,
    borderLeft: false,
    backgroundColor: '',
    useBackgroundColor: false,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0,
    paddingLeft: 0,
    guid: '',
  }

  tab = 0;

  get numberRules() {
    return [notValidNumber(this.$t('invalidNumberError'))];
  }

  get fontSizeNumberRules() {
    return [notNumberInBetweenNegative(this.$t('invalidNumberError'), -10, 10)];
  }

  get borderWidthRules() {
    return [notNumberInBetweenNegative(this.$t('invalidNumberError'), 1, 25)];
  }

  get lineHeightRules() {
    return [notNumberInBetweenNegative(this.$t('invalidNumberError'), 1, 50)];
  }

  get alignsOptions() {
    return [
      { name: this.$t('stretch'), value: 'stretch' },
      { name: this.$t('start'), value: 'start' },
      { name: this.$t('end'), value: 'end' },
      { name: this.$t('center'), value: 'center' },
    ];
  }

  get textAlignsOptions() {
    return [
      { name: this.$t('left'), value: 'left' },
      { name: this.$t('center'), value: 'center' },
      { name: this.$t('right'), value: 'right' },
    ];
  }

  get fontUnitOptions() {
    return [
      { name: this.$t('rem'), value: 'rem' },
      { name: this.$t('em'), value: 'em' },
      { name: this.$t('%'), value: '%' },
      { name: this.$t('vh'), value: 'vh' },
      { name: this.$t('vw'), value: 'vw' },
      { name: this.$t('ch'), value: 'ch' },
      { name: this.$t('px'), value: 'px' },
    ];
  }

  @Watch('selectedGridItemConfiguration', { immediate: true })
  onSelectedGridItemConfigurationChange(updatedValue, previousValue) {
    if ((updatedValue !== previousValue) && updatedValue) {
      this.form.showMasterSaleFormat = updatedValue.showMasterSaleFormat;
      this.form.hideTitle = updatedValue.hideTitle;
      this.form.justifyContent = updatedValue.justifyContent;
      this.form.alignContent = updatedValue.alignContent;
      this.form.borderWidth = updatedValue.borderWidth;
      this.form.borderTop = updatedValue.borderTop;
      this.form.borderBottom = updatedValue.borderBottom;
      this.form.borderRight = updatedValue.borderRight;
      this.form.borderLeft = updatedValue.borderLeft;
      this.form.guid = updatedValue.guid;
      this.form.paddingLeft = String(updatedValue.paddingLeft);
      this.form.paddingTop = String(updatedValue.paddingTop);
      this.form.paddingRight = String(updatedValue.paddingRight);
      this.form.paddingBottom = String(updatedValue.paddingBottom);
      this.form.useCustomFontSize = updatedValue.useCustomFontSize;
      this.form.fontSizeThreshold = String(updatedValue.fontSizeThreshold);
      this.form.useFontSizeRatio = updatedValue.useFontSizeRatio;
      this.form.fontSize = updatedValue.fontSize;
      this.form.fontSizeUnit = String(updatedValue.fontSizeUnit);
      this.form.useCustomFontColor = updatedValue.useCustomFontColor;
      this.form.fontColor = updatedValue.fontColor;
      this.form.textAlign = updatedValue.textAlign;
      this.form.useBackgroundColor = updatedValue.useBackgroundColor;
      this.form.backgroundColor = updatedValue.backgroundColor;
      this.form.useLineHeight = updatedValue.useLineHeight;
      this.form.lineHeight = updatedValue.lineHeight;
    }
  }

  @Watch('form', { deep: true })
  onFormChange(updatedValue) {
    this.updateMenuGridItemConfiguration(updatedValue);
  }
}
</script>
<style>
.subtitle-grid-item {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
  margin-bottom: 5px;
  text-align: center;
}

.my-tabs .v-tab {
  flex: 1;
  justify-content: center;
}

.my-tabs .theme--light.v-icon {
  color: #032c58;
}

.form-grid-item-config {
  width: 100%;
}
</style>
